var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loginContainer" },
    [
      _c("LoginHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "login-content outer-container" }, [
        _c(
          "form",
          {
            staticClass: "form-signin inner-container",
            attrs: { id: "form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.updatePassword()
              }
            }
          },
          [
            _c("div", { staticClass: "wellmetrics-event-pl" }, [
              _vm._v("WELLMETRICS EVENT PLANNER")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "subText" }, [
              _vm._v(
                "Create, request and schedule biometric screening events with ADURO"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formInput" }, [
              _c("div", [
                _c("div", { staticClass: "form-title" }, [
                  _vm._v(
                    "\n            Enter your new password to reset.\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row inputText" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newPassword,
                            expression: "newPassword"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          "data-vv-as": "new password",
                          name: "newPassword"
                        },
                        domProps: { value: _vm.newPassword },
                        on: {
                          blur: function($event) {
                            _vm.validateInput("newPassword")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newPassword = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "errorBackground",
                        class: {
                          errorBackgroundColor:
                            (_vm.errors.has("newPassword") &&
                              _vm.validatedFields.includes("newPassword")) ||
                            !_vm.isPasswordContainsNumber
                        }
                      },
                      [
                        _vm.validatedFields.includes("newPassword")
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.first("newPassword"),
                                    expression: "errors.first('newPassword')"
                                  }
                                ],
                                staticClass: "errorDetail"
                              },
                              [_vm._v(_vm._s(_vm.errors.first("newPassword")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isPasswordContainsNumber &&
                        !_vm.errors.has("newPassword")
                          ? _c("span", { staticClass: "errorDetail" }, [
                              _vm._v(
                                "The New password must contains at least 1 digit"
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row inputText" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.reNewPassword,
                            expression: "reNewPassword"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              confirmed: _vm.newPassword
                            },
                            expression:
                              "{ required: true, confirmed: newPassword }"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          "data-vv-as": "password",
                          name: "repeatPassword"
                        },
                        domProps: { value: _vm.reNewPassword },
                        on: {
                          blur: function($event) {
                            _vm.validateInput("repeatPassword")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.reNewPassword = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "errorBackground",
                        class: {
                          errorBackgroundColor:
                            _vm.errors.has("repeatPassword") &&
                            _vm.validatedFields.includes("repeatPassword")
                        }
                      },
                      [
                        _vm.validatedFields.includes("repeatPassword")
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("repeatPassword"),
                                    expression: "errors.has('repeatPassword')"
                                  }
                                ],
                                staticClass: "errorDetail"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("repeatPassword"))
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "password-check-list" }, [
                  _c("div", { staticClass: "password-at-least" }, [
                    _vm._v("Password must have at least:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "indicators-password row" }, [
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.length
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("8 characters ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.lowerCaseChars
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("4 lowercase letters (a-z)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.upperCaseChars
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("1 uppercase letter (A-Z)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.numbers
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("2 numbers (0-9)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.specialChars
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("1 special character")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row footerForm" }, [
                  _c("div", { staticClass: "col-md-9 forgotPassword" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-reset-password",
                        attrs: { type: "submit", disabled: _vm.isDisabled }
                      },
                      [_vm._v("Update password")]
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("New password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("New password again")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f1dee778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1dee778","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorization/UpdatePassword.vue
// module id = 1855
// module chunks = 1